import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import 'swiper/swiper-bundle.min.css';
import { maxWidth } from '@mui/system';


const myComponentStyle = {
    maxWidth: '100% !important',
  };


export const HomeSlider = () => {
    
    
  return (
    <>
    <style>
   {`
   .banner-section {
    width: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
    .homeSlider {
      width: 100%;
    }

.banner-image {
  width: 100%;
  overflow: hidden;
}

.banner-image img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
  border-radius: 16px;
}

/* Tablet */
@media (max-width: 992px) {
  .banner-image img {
    height: 350px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .homeSlider {
    padding: 10px 0;
  }

  .container {
    padding-left: 10px;
    padding-right: 10px;
  }

  .container .banner-img {
    border-radius: 12px;
  }

  .container .banner-img {
    object-fit: contain;
    background: #f5f5f5;
    border-radius: 12px;
  }
}
   `}
      </style>
    <div className='section homeSlider py-4'>
        <div className='container' style={myComponentStyle}>
        <div className='banner-img'><img src='/assets/img/banner/banner-3.jpg'></img></div> 

        {/* <Swiper 
                loop={true}
                spaceBetween={30} 
                navigation={true} 
                modules={[Navigation,Autoplay]}
                autoplay={{delay:1000,
                    disableOnInteraction:false
                }}
                speed={2000}
                className="sliderHome">
            <SwiperSlide className=''>
                <div className='' style={{ 'border-radius':'25px; border: 2px solid #2322221c'}}><img src='/assets/img/banner/banner-1.jpg'></img></div>
            </SwiperSlide>
            <SwiperSlide className=''>
                <div style={{ 'border': '2px solid #2322221c;', 'border-radius':'25px'}}><img src='/assets/img/banner/banner-2.jpg'></img></div>
            </SwiperSlide>
            <SwiperSlide className=''>
                <div className='item rounded-[20px] overflow-hidden'><img src='/assets/img/banner/banner-3.jpg'></img></div> 
            </SwiperSlide>
            <SwiperSlide className=''>
                <div className='item rounded-[20px] overflow-hidden'><img src='/assets/img/banner/banner-4.jpg'></img></div> 
            </SwiperSlide>
        </Swiper> */}
        </div>
      </div>
      </>
  )
}

export default HomeSlider;